export const OrgResultsConst = {
    FETCH_USER_LIST: "FETCH_USER_LIST",
    PUSH_DEFAULT_USER_LIST: "PUSH_DEFAULT_USER_LIST",
    UPDATE_ORG_RESULTS: "UPDATE_ORG_RESULTS",
    UPDATE_POPUP_DATA: "UPDATE_POPUP_DATA"
}